import React, { useState } from 'react';
import {
  Box,
  TextField,
  Switch,
  FormControlLabel,
  Typography,
  Grid,
} from '@mui/material';
import PropTypes from 'prop-types';

/**
 * FormElementsShowcase Component
 * Displays form elements with theme styling
 */
const FormElementsShowcase = ({ theme }) => {
  const [textFieldValue, setTextFieldValue] = useState('Sample text');
  const [switchChecked, setSwitchChecked] = useState(true);

  return (
    <Grid size={{ xs: 12, md: 6 }}>
      <Typography variant="subtitle2" gutterBottom>
        Form Elements
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label="Text Input"
          value={textFieldValue}
          onChange={e => setTextFieldValue(e.target.value)}
          variant="outlined"
          fullWidth
          sx={{
            '& .MuiInputLabel-root': { color: theme.text_color },
            '& .MuiOutlinedInput-root': {
              color: theme.text_color,
              '& fieldset': { borderColor: theme.surface_color },
              '&:hover fieldset': { borderColor: theme.primary_color },
              '&.Mui-focused fieldset': {
                borderColor: theme.primary_color,
              },
            },
          }}
        />
        <FormControlLabel
          control={
            <Switch
              checked={switchChecked}
              onChange={e => setSwitchChecked(e.target.checked)}
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                  color: theme.primary_color,
                },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                  backgroundColor: theme.primary_color,
                },
              }}
            />
          }
          label="Toggle Switch"
          sx={{ color: theme.text_color }}
        />
      </Box>
    </Grid>
  );
};

FormElementsShowcase.propTypes = {
  theme: PropTypes.object.isRequired,
};

export default FormElementsShowcase;
